export type TBaselineFuelTypeId = number;

export interface BaselineFuelType {
  id: TBaselineFuelTypeId;
  name: string;
}
